"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var react_phone_input_2_1 = require("react-phone-input-2");
require("./theme.scss");
var PhoneNumberInput = /** @class */ (function (_super) {
    tslib_1.__extends(PhoneNumberInput, _super);
    function PhoneNumberInput(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.setExposedRef = function (el) {
            var exposedRef = _this.props.exposedRef;
            exposedRef && exposedRef(el);
        };
        _this.onChange = function (value) {
            var _a = _this.props, onChange = _a.onChange, name = _a.name;
            var val = value === "" ? null : value;
            var element = {
                target: {
                    name: name,
                    value: val,
                    type: "text"
                }
            };
            onChange && onChange(element);
        };
        _this.onValidationChange = function (inputNumber) {
            var required = _this.props.required;
            /* Do not simplify this statement! */
            if (!inputNumber && required) {
                return false;
            }
            return true;
        };
        return _this;
    }
    PhoneNumberInput.prototype.render = function () {
        var _a = this.props, className = _a.className, theme = _a.theme, value = _a.value, defaultValue = _a.defaultValue, focus = _a.focus, disabled = _a.disabled, required = _a.required, readOnly = _a.readOnly, fill = _a.fill, invalid = _a.invalid, exposedRef = _a.exposedRef, placeholder = _a.placeholder, label = _a.label, name = _a.name, onChange = _a.onChange, others = tslib_1.__rest(_a, ["className", "theme", "value", "defaultValue", "focus", "disabled", "required", "readOnly", "fill", "invalid", "exposedRef", "placeholder", "label", "name", "onChange"]);
        var phoneNumberInputProps = tslib_1.__assign({}, others, { className: "react-tel-input", disabled: disabled,
            required: required,
            readOnly: readOnly,
            value: value,
            defaultValue: defaultValue,
            placeholder: placeholder });
        return React.createElement(react_phone_input_2_1.default, tslib_1.__assign({ specialLabel: "", enableSearch: true, country: "us", countryCodeEditable: true, enableAreaCodes: false, onChange: this.onChange, isValid: this.onValidationChange, prefix: "", inputProps: {
                name: name,
                required: required,
                autoFocus: focus,
                ref: this.setExposedRef,
            } }, phoneNumberInputProps));
    };
    return PhoneNumberInput;
}(React.Component));
exports.default = PhoneNumberInput;
